import { CognitoIdentityProviderClient, InitiateAuthCommand } from "@aws-sdk/client-cognito-identity-provider";
import {CLIENT_ID, REGION} from "./config";


const cognitoClient = new CognitoIdentityProviderClient({ region: REGION });

export const refreshAccessToken = async () => {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
        console.error("No refresh token found.");
        return;
    }

    const params = {
        AuthFlow: "REFRESH_TOKEN_AUTH",
        ClientId: CLIENT_ID,
        AuthParameters: {
            REFRESH_TOKEN: refreshToken,
        },
    };

    try {
        const command = new InitiateAuthCommand(params);
        const response = await cognitoClient.send(command);

        if (response.AuthenticationResult) {
            localStorage.setItem("accessToken", response.AuthenticationResult.AccessToken);
            localStorage.setItem("idToken", response.AuthenticationResult.IdToken);
            console.log("Access token refreshed successfully.");
        }
    } catch (error) {
        console.error("Error refreshing access token:", error);
    }
};

export const getValidAccessToken = async () => {
    const token = localStorage.getItem("accessToken");

    if (!token || isTokenExpired(token)) {
        await refreshAccessToken();
    }

    return localStorage.getItem("accessToken");
};

const isTokenExpired = (token) => {
    if (!token) return true;
    const decoded = JSON.parse(atob(token.split(".")[1]));
    const expiry = decoded.exp * 1000;
    return Date.now() >= expiry;
};
